// src/App.jsx
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/header";
import InfoBanner from "./components/infoBanner";
import Footer from "./components/footer";
import MainPage from "./components/Homepage";
import MenuPage from "./components/MenuPage";
import AboutPage from "./components/aboutPage";
import "./index.css";

export default function App() {
  return (
    <BrowserRouter>
      <Header />
      <InfoBanner />
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/about" element={<AboutPage />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}